// material-ui
import { Box, IconButton } from "@mui/material";
import Button from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";
import * as React from "react";
import { useHistory } from "react-router-dom";
import OpenMenuIcon from "../../../../../assets/menu/openMenuIcon";
import { getRouteUrl } from "../../../../../helpers/routing/getRouteUrl";
import useMenuAction from "../../../../../hooks/menu/useMenuAction";
import useMenuData from "../../../../../hooks/menu/useMenuData";
import { ROUTE_PAGE_HOME } from "../../../../../routers/routes";
import Logo from "../../../../custom/general/logo/logo";
import DrawerHeaderStyled from "./drawerHeaderStyled";

// ==============================|| DRAWER HEADER ||============================== //

const DrawerHeader = () => {
	const { setDrawerOpen } = useMenuAction()
	const { drawerOpen } = useMenuData()
	const history = useHistory()
	const theme = useTheme();
	return (
		<DrawerHeaderStyled
			open={drawerOpen}
			sx={{
				minHeight: drawerOpen ? '60px' : 'inherit',
				width: 'inherit',
				paddingTop: !drawerOpen ? '8px' : 0,
				paddingBottom: !drawerOpen ? '16px' : 0,
				paddingLeft: 0,
				backgroundColor: '#FFFFFF',
				justifyContent: drawerOpen ? 'start' : 'center'
			}}
		>
			{!drawerOpen ? (
				<Box>
					<Box>
						<IconButton
							onClick={() => {
								setDrawerOpen(true)
							}}
							sx={{
								display: 'flex',
								padding: '24px',
								alignItems: 'center',
								justifyContent: 'center',
								'&:hover': {
									background: 'none'
								}
							}}
						>
							<OpenMenuIcon/>
						</IconButton>
					</Box>
					<Box sx={{display: 'flex', justifyContent: 'center'}}>
						<Button
							variant={'text'}
							sx={{
								padding: 0, // Αφαιρεί περιττά padding
								// paddingLeft: 0.5,
								minWidth: "unset", // Κάνει το button να "αγκαλιάζει" το λογότυπο
							}}
							onClick={(e) => {
								e.stopPropagation()
								history.push(getRouteUrl(ROUTE_PAGE_HOME))
							}}
						>
							<Logo
								auth
								style={{
									maxHeight: '50px',
									background: '#FFFFFF',
								}}
							/>
						</Button>
					</Box>
				</Box>
			) : (
				<Box
					sx={{
						paddingBottom: 0,
						display: 'flex',
						justifyContent: 'center',
						width: '100%',
					}}
				>
					<Button
						variant={'text'}
						sx={{
							padding: 0, // Αφαιρεί περιττά padding
							minWidth: "unset", // Κάνει το button να "αγκαλιάζει" το λογότυπο
						}}
						onClick={(e) => {
							e.stopPropagation()
							history.push(getRouteUrl(ROUTE_PAGE_HOME))
						}}
					>
						<Logo
							auth
							style={{
								maxHeight: '50px',
								background: '#FFFFFF'
							}}
						/>
					</Button>
				</Box>
			)}
		</DrawerHeaderStyled>
	);
};

// DrawerHeader.propTypes = {
//     open: PropTypes.bool
// };

export default DrawerHeader;
